<template>
  <div class="main_div">
    <div class="wrap">
      <div class="header_wrap" :class="{'m_black' : checkTheme}">
        <TopMenu main="Y" :black-theme="checkTheme" />
      </div>
    </div>
    <div class="container">
      <div class="home">
        <div ref="banner" class="home_top">
          <div class="home_top_area">
            <Banner />
          </div>
        </div>
        <div class="home_menu">
          <div class="section">
            <div class="home_title">
              <span class="stitle">
                <img src="@/assets/images/logo_text_white.png" alt="Tranggle" />
              </span>트랭글러들과 함께
            </div>
            <div class="home_menu_area">
              <router-link to="/activity/main" class="block_click">
                <span class="menu">
                  <span class="menu_icon m1"></span>
                  <span class="menu_text">
                    <span class="t1">나의 활동</span>
                    <span class="t2">
                      걸음, 운동 기록 등 나의 활동<br />
                      데이터를 확인하고<br />
                      원하는 대상과 비교 가능
                    </span>
                  </span>
                </span>
              </router-link>
              <router-link to="/course" class="block_click">
                <span class="menu">
                  <span class="menu_icon m2"></span>
                  <span class="menu_text">
                    <span class="t1">코스</span>
                    <span class="t2">
                      나의 코스를 비롯하여<br />
                      코스비교, 제안, 테마별 코스,<br />
                      코스북 등 다양한 코스 확인
                    </span>
                  </span>
                </span>
              </router-link>
              <router-link to="/mission" class="block_click">
                <span class="menu">
                  <span class="menu_icon m3"></span>
                  <span class="menu_text">
                    <span class="t1">미션</span>
                    <span class="t2">
                      트랭글 전체 미션 검색,<br />
                      현재 내가 개설한 미션 및<br />
                      참가중인 미션 확인
                    </span>
                  </span>
                </span>
              </router-link>
              <!-- <router-link to="/club" class="block_click">
                <span class="menu">
                  <span class="menu_icon m4"></span>
                  <span class="menu_text">
                    <span class="t1">클럽</span>
                    <span class="t2">
                      종목·지역별 클럽 검색,<br />
                      클럽에서 진행 중인 미션 및<br />
                      내가 가입한 클럽 정보 확인
                    </span>
                  </span>
                </span>
              </router-link> -->
              <!-- <router-link to="/story" class="block_click">
                <span class="menu">
                  <span class="menu_icon m5"></span>
                  <span class="menu_text">
                    <span class="t1">스토리</span>
                    <span class="t2">
                      수많은 트랭글러들이 올린<br>
                      스토리를 볼 수 있으며<br>
                      내가 작성한 스토리 손쉽게 확인
                    </span>
                  </span>
                </span>
              </router-link> -->
            </div>
          </div>
        </div>
        <div class="home_app">
          <span class="home_app_g">
            <div class="app_text">
              <span class="text_tranggle"></span>
              <strong>게임 같은 운동앱</strong>
              <p>
                맞춤 서비스로 더욱 새로워진 트랭글,<br />
                다양한 운동과 코스 공유를 통해서<br class="m-br" />
                운동을 더욱 즐겁게 해보세요<br />
              </p>
              <div class="app_btn">
                <a href="https://play.google.com/store/apps/details?id=com.beaglemap.tranggle"  target="_blank" class="store_google">
                  <span>구글 플레이</span>
                </a>
                <a href="https://itunes.apple.com/app/id505902704" target="_blank" class="store_apple">
                  <span>앱스토어</span>
                </a>
              </div>
            </div>
            <div class="app_img">
              <img src="../assets/images/home/watch+phone_mockup.png" alt="">
              <!-- <div class="img_tranggle"></div> -->
            </div>
          </span>
        </div>
      </div>
      <footers ref="footer"/>
    </div><!--/container-->
    <NoticeLayerPopup
      link-url="https://gifted-banjo-553.notion.site/294d3b7f868a80259f32cd46cc62fa66"
      button-text="개인정보 이전 동의안 전문 확인">
      <div class="merger_notice_content">
        <h1 class="merger_title">(주)비글과 (주)카카오브이엑스의 합병에 따른 개인정보 이전 안내</h1>

        <p class="merger_greeting">
          회원님, 안녕하세요.<br>
          항상 트랭글을 이용해 주셔서 진심으로 감사드립니다.
        </p>

        <p class="merger_main_text">
          트랭글 운영사 (주)비글이 (주)카카오VX로 2025년 11월 28일부로 합병될 예정입니다.<br>
          이에 따라 (주)비글이 보유하는 회원님의 개인 정보는 (주)카카오VX로 모두 이전됨을 안내드립니다.
        </p>

        <p class="merger_detail_text">
          개인정보를 양수받는 법인에 대한 세부 정보는 다음과 같습니다.
        </p>

        <div class="merger_info_box">
          <h3>【개인정보를 양수받는 법인】</h3>
          <ul>
            <li>- 법인명 : (주)카카오브이엑스</li>
            <li>- 주소 : 경기도 성남시 분당구 판교로255번길 68(삼평동) 유비쿼스빌딩 4F</li>
          </ul>
        </div>

        <div class="merger_info_box">
          <h3>【개인정보 이전 거부 시 조치 방법】</h3>
          <p>- 트랭글 앱 내 [나의 활동 > 설정 > 계정 관리 > 탈퇴하기]를 통한 회원탈퇴</p>
        </div>

        <p class="merger_detail_text">
          보다 자세한 사항은 개인정보 이전 통지안에서 확인하실 수 있습니다.
        </p>

        <div class="merger_closing">
          <p>
            (주)카카오브이엑스는 (주)비글의 모바일서비스를 기존 운영방식에 따라 제공하며,<br>
            회원여러분들께 어떤 불편도 드리지 않을 것을 약속드립니다.<br>
            회원 여러분의 지속적인 서비스이용과 변함없는 사랑을 부탁드립니다.<br>
            감사합니다.
          </p>
        </div>
      </div>
    </NoticeLayerPopup>
  </div>
</template>

<script>

import TopMenu from '../components/common/TopMenu.vue'
import Banner from '@/components/home/Banner.vue'
import footers from '../components/support/footer.vue'
import NoticeLayerPopup from '@/components/common/NoticeLayerPopup.vue'
import { mapState } from 'vuex'
export default {
  name: 'Home',
  components: {
    TopMenu,
    Banner,
    footers: footers,
    NoticeLayerPopup
  },
  data () {
    return {
      currentTime: '',
      checkTheme: false,
      thirdDateOver: ''
    }
  },
  computed: {
    ...mapState('UserSet', [
      'isOpenthirdPopup'
    ])
  },
  mounted () {
    // this.getCurrentTime()
    setInterval(this.getCurrentTime.bind(this), 1000)
    const fullH = document.getElementsByTagName('html')[0].clientHeight
    document.getElementsByClassName('home_top_area')[0].style.height = `${fullH}px`
    document.addEventListener('scroll', this.checkScroll)
    // console.log(new Date())
    // 제 3자 제공동의 변경 팝업 2월 26일까지만 노출 2월 27일 이후 삭제
    if (new Date(2023, 1, 27) <= new Date()) {
      this.thirdDateOver = 'Y'
    }
  },
  unmounted () {
    document.removeEventListener('scroll', this.checkScroll)
  },
  beforeCreate () {
    // if (this.$route.query.token != null) {
    //   this.axios.get('/member/info.json', {
    //     params: {
    //       token: this.$route.query.token
    //     }
    //   })
    //     .then(data => {
    //       const memberResponseData = data.data.response
    //       const memberResponseCode = memberResponseData.code

    //       if (memberResponseCode === '00') {
    //         const memberInfo = memberResponseData.content

    //         this.$store.state.Member.token = this.$route.query.token
    //         this.$store.state.Member.memberId = memberInfo.id
    //         this.$store.commit('Member/setMemberInfo', memberInfo)
    //         this.$router.push('/')
    //       }
    //     })
    // }
  },
  methods: {
    setDate () {
      const year = new Date().getFullYear()
      const month = new Date().getMonth() + 1 < 10 ? '0' + (new Date().getMonth() + 1) : new Date().getMonth() + 1
      const date = new Date().getDate() < 10 ? '0' + new Date().getDate() : new Date().getDate()
      const hh = new Date().getHours() < 10 ? '0' + new Date().getHours() : new Date().getHours()
      const mm = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes()
      const ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds()
      return {
        year: year,
        month: month,
        date: date,
        hh: hh,
        mm: mm,
        ss: ss
      }
    },
    getCurrentTime () {
      this.currentTime = this.setDate().hh + '<span>：</span>' + this.setDate().mm + '<span>：</span>' + this.setDate().ss
    },
    checkScroll (e) {
      const cScroll = e.srcElement.scrollingElement.scrollTop
      const containOffsetY = document.getElementsByClassName('home_menu')[0].offsetTop
      const homeAppOffsetY = document.getElementsByClassName('home_app')[0].offsetTop
      if (cScroll > containOffsetY) {
        this.checkTheme = true
      } else {
        this.checkTheme = false
      }
      if (cScroll > homeAppOffsetY) {
        this.checkTheme = false
      }
    }
  }
}
</script>

<style scoped>
.merger_notice_content {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  line-height: 1.5;
  color: #333;
  font-size: 14px;
}

.merger_title {
  font-size: 20px;
  font-weight: bold;
  line-height: 1.3;
  margin-bottom: 20px;
  color: #000;
}

.merger_greeting {
  margin-bottom: 15px;
  line-height: 1.6;
}

.merger_main_text {
  margin-bottom: 15px;
  line-height: 1.6;
}

.merger_detail_text {
  margin-bottom: 12px;
  line-height: 1.6;
}

.merger_info_box {
  background-color: #f5f5f5;
  padding: 10px;
  margin-bottom: 12px;
  border-radius: 4px;
}

.merger_info_box h3 {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 5px;
  color: #000;
}

.merger_info_box ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.merger_info_box li {
  margin-bottom: 6px;
  line-height: 1.5;
  font-size: 13px;
}

.merger_info_box p {
  margin: 0;
  line-height: 1.6;
  font-size: 13px;
}

.merger_closing {
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid #e0e0e0;
}

.merger_closing p {
  line-height: 1.6;
  margin: 0;
  font-size: 13px;
}
</style>
